import { apiRequest } from "./api";
import { authApi } from "./auth";
import { hasCsrfToken } from "./csrf";
import type { FeedbackSubmissionRequestDto } from "../types/types";

export const feedbackApi = {
  async submit(payload: FeedbackSubmissionRequestDto): Promise<void> {
    if (!hasCsrfToken()) {
      await authApi.csrf();
    }

    return apiRequest<void>("/api/feedback", {
      method: "POST",
      body: payload,
    });
  },
};
